import {db, storage} from "../firebase.config";
import {ProjectModel} from "../model/project";
import {SummaryModel} from "../model/summary";
import {ExperienceModel} from "../model/experience";
import {ServiceModel} from "../model/service";
import {EducationModel} from "../model/education";
import {SkillCategory, SkillModel} from "../model/skill";
export class ProjectRepository {
    private summaryCollection = db.collection('summary');
    private serviceCollection = db.collection('service');
    private experienceCollection = db.collection('experience');
    private educationCollection = db.collection('education');
    private skillCollection = db.collection('skill');
    private projectCollection = db.collection('project');
    async getAllProject(): Promise<Array<ProjectModel>> {
        try {
            const result = await this.projectCollection.get()
            return result.docs.map(value => value.data() as unknown as ProjectModel)

        } catch (e) {
            console.log(e);
            throw e;
        }
    }
    async getAllService(): Promise<Array<ServiceModel>> {
        try {
            const result = await this.serviceCollection.get()
            return result.docs.map(value => {
                const service = value.data() as unknown as ServiceModel
                storage.ref("image/" + service.title.toLowerCase().replaceAll(' ','_') + ".png").getDownloadURL().then(value1 => {
                    service.iconUrl = value1
                })
                return service;
            })
        } catch (e) {
            console.log(e);
            throw e;
        }
    }
    async getAllEducation(): Promise<Array<EducationModel>> {
        try {
            const result = await this.educationCollection.get()
            return result.docs.map(value => value.data() as unknown as EducationModel)
        } catch (e) {
            console.log(e);
            throw e;
        }
    }
    async getAllExperience(): Promise<Array<ExperienceModel>> {
        try {
            const result = await this.experienceCollection.get()
            return result.docs.map(value => value.data() as unknown as ExperienceModel)
        } catch (e) {
            console.log(e);
            throw e;
        }
    }
    async getAllSkill(): Promise<Array<SkillModel>> {
        try {
            const result = await this.skillCollection.get()
            const skills: Array<SkillModel> = []
            for (let value of result.docs) {
                const data = value.data(); // data = {data : [.....]}
                const subSkills: Array<SkillModel> = data.data;  //Ex: subSkills = tool [.....]
                for(let skill of subSkills) {
                    skill.category = value.id
                    skill.orderNumber = data.orderNumber;
                    skills.push(skill);
                }
            }
            return skills
        } catch (e) {
            console.log(e);
            throw e;
        }
    }
    async getSkillIconURL(skill: SkillModel): Promise<string> {
        try {
                    const iconName = skill.title.toLowerCase()
                        .replaceAll('.', '')
                        .replaceAll(' ', '_')
                        .replaceAll('/', '_')
                    return await storage.ref("image/" + iconName + ".png").getDownloadURL()
        } catch (e) {
            console.log(e);
            throw e;
        }
    }
    async getSummary(): Promise<SummaryModel> {
        try {
            const result = await this.summaryCollection.get()
            const value = result.docs.at(0)
            const data = value?.data();
            const summary = data as SummaryModel;
            return summary
        } catch (e) {
            console.log(e);
            throw e;
        }
    }

    async getResumeURL(): Promise<string> {
        return storage.ref("documents/" + "Resume.pdf").getDownloadURL()
    }

    async getProfileLightURL(): Promise<string> {
        return storage.ref("image/" + "profile-fuma-light.png").getDownloadURL()
    }

    async getProfileDarkURL(): Promise<string> {
        return storage.ref("image/" + "profile-fuma-dark.png").getDownloadURL()
    }
}